import createRefs from "./create-refs.js";

const ref = {
	createRefs,
};

export default ref;
